// extracted by mini-css-extract-plugin
export default {"container":"OrderForm_container__fcmOx","localityInput":"OrderForm_localityInput__WwWGt","orderItemsHeader":"OrderForm_orderItemsHeader__YJdoA"};